
import { useMemo, useCallback } from 'react';
import { useHistory } from 'react-router-dom';

const getQueryParams = (search) => {
  search = (search || '?').substr(1);
  return new URLSearchParams(search);
};

const useQueryParam = (param, defaultVal = '') => {
  const history = useHistory();
  const value = useMemo(() => {
    if (param) {
      const searchParams = getQueryParams(history.location.search);
      return searchParams.has(param) ? searchParams.get(param) : defaultVal;
    }
  }, [history.location.search, param, defaultVal]);

  const setQueryParam = useCallback((newVal) => {
    if (param) {
      const searchParams = getQueryParams(history.location.search);
      newVal = newVal !== undefined && newVal !== null ? newVal.toString().trim() : '';
  
      if (newVal !== '') {
        searchParams.set(param, newVal);
      } else {
        searchParams.delete(param);
      }
  
      const pathname = history.location.pathname;
      const newUrl = `${pathname}?${searchParams.toString()}`;
      history.replace(newUrl, null);
    }
  }, [
    history,
    param
  ]);

  return [value, setQueryParam];
};

export default useQueryParam;
